
import React from 'react';
import { motion } from 'framer-motion';

interface CTASectionProps {
  onApplyClick: () => void;
}

const CTASection: React.FC<CTASectionProps> = ({ onApplyClick }) => {
  return (
    <section className="py-32 px-6 bg-black relative overflow-hidden">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#FFC222]/10 blur-[120px] rounded-full pointer-events-none"></div>
      
      <div className="max-w-4xl mx-auto text-center relative z-10">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-4xl md:text-7xl font-black mb-8 leading-tight">
            "경험"이 아닌 <br />
            <span className="text-[#FFC222]">"변화"하는 1년</span>을 만드세요.
          </h2>
          <p className="text-zinc-400 text-lg md:text-xl mb-12 max-w-2xl mx-auto">
            ENACTUS YM의 여정은 지금부터 시작입니다.<br />
            세상을 바꿀 당신의 첫 번째 임팩트를 응원합니다.
          </p>
          <button 
            onClick={onApplyClick}
            className="group relative inline-flex items-center justify-center px-10 py-5 font-black text-black bg-[#FFC222] rounded-full overflow-hidden transition-all duration-300 hover:scale-105 active:scale-95 text-xl"
          >
            ENACTUS YM 17기 지원하기
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
